import dayjs from 'dayjs'

export default function (trainingCourse) {
  return dayjs().isBefore(dayjs(trainingCourse.date))
}
